import React from 'react';
import classNames from 'classnames';

import blueQuestionMark from '../../public/images/blue-question-mark.svg';
import StarRating from '../CardElements/StarRating';
import RadioBtnCard from '../RadioBtnCard';

import { GMAPS_API_KEY } from '@evdy/web-redux/dist/constants';
import { normalizeStateProvince } from '@evdy/web-core/dist/lib/utils';

import styles from './ProviderCards.module.scss';

import noResults from '../../public/images/no-results-search-icon.svg';
import servedHeart from '../../public/images/served-family-heart.svg';
import houseImg from '../../public/images/provider-house.svg';

const {
  // what if card classes
  'what-if-card': whatIfCardClass,
  'question-mark': questionMarkImg,
  'title-wrapper': titleWrapperClass,
  flower: flowerImg,
  title: titleCopyClass,
  body: bodyCopyClass,
  // provider card classes
  'provider-card': providerCardClass,
  'radio-btn-card': radioBtnCardClass,
  'main-card-content': mainCardContentClass,
  'provider-content': cardContentClass,
  'provider-img-map': providerImageMapClass,
  'preferred-provider': preferredProviderClass,
  'provider-img': providerImgClass,
  'provider-map': providerMapClass,
  'provider-address': providerAddressClass,
  name: providerNameClass,
  header: headerClass,
  // no results card
  'no-results-card': noResultsCardClass
} = styles;

const createMapImgUrl =
  coords => `https://maps.googleapis.com/maps/api/staticmap?center=${coords[0]},${coords[1]}&zoom=15&size=250x125&maptype=road
&markers=icon:s3://everdays-resources/icons/map-pin.png|${coords[0]},${coords[1]}&key=${GMAPS_API_KEY}`;

const ProviderCard = ({
  provider,
  headerColor,
  fillColor,
  fieldName,
  value,
  isChecked,
  packageId,
  headerCopy,
  extraMargin,
  idx
}) => {
  const {
    address,
    name = '',
    ratingsInfo,
    coords = [],
    profileImage,
    preneedPackages = []
  } = provider ?? {};

  const { street, city, state, zip } = address ?? {};
  const { average: rating } = ratingsInfo ?? {};

  const isPreferred = !!preneedPackages.length;

  const providerCardClasses = classNames(providerCardClass, {
    'extra-margin': extraMargin
  });

  return (
    <div className={providerCardClasses}>
      {!!headerCopy && (
        <div className={classNames(headerClass, { active: isChecked })}>
          <img src={servedHeart} alt="served-fam" />
          {headerCopy}
        </div>
      )}
      <RadioBtnCard {...{ fieldName, name, value, isChecked }} customClass={radioBtnCardClass}>
        <div className={mainCardContentClass}>
          {isPreferred && <p className={preferredProviderClass}>preferred</p>}
          <div className={providerImageMapClass}>
            <img
              className={classNames(providerImgClass, { 'provider-profile-img': !!profileImage })}
              src={profileImage || houseImg}
              alt="provider"
            />
            <img className={providerMapClass} src={createMapImgUrl(coords)} alt="map" />
          </div>
          <div className={cardContentClass}>
            <div className={providerNameClass}>{name}</div>
            <div className={providerAddressClass}>
              <p>
                {street}
                {` ${city}, ${normalizeStateProvince(state)} ${zip}`}
              </p>
            </div>
            {rating > 0 && <StarRating {...{ rating }} blueStar />}
          </div>
        </div>
      </RadioBtnCard>
    </div>
  );
};

const NoResultsCard = () => (
  <div className={noResultsCardClass}>
    <img src={noResults} alt="no-results" />
    <p>No results found</p>
  </div>
);

const WhatIfCard = ({ titleCopy, bodyCopy }) => (
  <div className={whatIfCardClass}>
    <div className={titleWrapperClass}>
      <img className={questionMarkImg} src={blueQuestionMark} alt="question" />
      <p className={titleCopyClass}>{titleCopy}</p>
    </div>
    <div className={flowerImg} />
    <p className={bodyCopyClass}>{bodyCopy}</p>
  </div>
);

export { ProviderCard, WhatIfCard, NoResultsCard };
